import _ from 'lodash';
import { AuthService } from "../auth/auth.service";

export class HistoricoService {
  /**
   * @param {AuthService} Auth
   * @param {*} PedidoResource
   */
  constructor(Auth, PedidoResource) {
    this.Auth = Auth;
    this.resource = PedidoResource;
  }

  /**
   * Solicita lista de OS
   */
  async getListaOs(params, offset, limit) {
    return this.resource.listaOs({
        offset: offset,
        limit: limit,
        numero: params && params.numeroPedido ? params.numeroPedido : null,
        dataCriacaoInicio: params && params.dataCriacaoInicial ? params.dataCriacaoInicial.mmyyyy() : null,
        dataCriacaoFim: params && params.dataCriacaoFinal ? params.dataCriacaoFinal.mmyyyy() : null,
        codigoSituacao: params && params.situacaoPedido ? params.situacaoPedido : null
    }).$promise;
  }

  /**
   * Solicita lista de encomendas
   */
  async getListaEncomendas(params, offset, limit) {
    return this.resource.listaItens(Object.assign({ offset, limit }, params)).$promise;
  }

  /**
   * Obtém dados de uma encomenda
   */
  async getPackage(params) {
    return this.resource.getPackage(params).$promise;
  }

  async getAtrasadas(offset, limit, params) {
    let filter;
    if (params) {
      filter = {...params, codigoRastreamento: params.rastreamento}
    }
    return this.resource.getAtrasadas({ offset, limit, ...filter }).$promise;
  }

  async getNaoEncontradas(offset, limit) {
    const user = this.Auth.getCurrentUser();

    return this.resource.getNaoEncontradas({
      offset,
      limit,
      id: user.id,
    }).$promise;
  }

  /**
   * solicita contador de não encontrados
   */
  async getContadorNaoEncontradas() {
    const user = this.Auth.getCurrentUser();

    return this.resource.getContadorNaoEncontradas({ id: user.id }).$promise;
  }

  /**
   * solicita contador de atrasadas
   */
  async getContadorAtrasadas() {
    return this.resource.getContadorAtrasadas().$promise;
  }

  /**
   * solicita filtros customizados
   */
  async getCustomFilter() {
    return this.resource.getCustomFilter().$promise;
  }

  /**
   * solicita a lista de encomendas para gerenciamento
   */
  async getPackages(params, offset, limit) {
    if (params) {
      if (params.rastreamento) {
        params.codigoRastreamento = params.rastreamento;
      }
      if (params.numeroPedido) {
        params.numeroOrdemServico = params.numeroPedido
      }
    }

    return this.resource.getPackages(Object.assign({ offset, limit }, params)).$promise;
  }

  /**
   * solicita os eventos sobre a entrega de uma encomenda
   */
  async getEventsPackage(id) {
    return this.resource.getEventsPackage({ id }).$promise;
  }

  async saveReverse(reverse) {
    return this.resource.saveReverse(reverse).$promise;
  }

  async getReverseDeliveryTypes(sender, recipientAddress, modalidade) {
    return this.resource.getReverseDeliveryTypes({
      nomeRemetente: sender.nome,
      cepRemetente: sender.endereco.codigoPostal,
      logradouroRemetente: sender.endereco.logradouro,
      numeroRemetente: sender.endereco.numero,
      bairroRemetente: sender.endereco.bairro,
      cidadeRemetente: sender.endereco.cidade,
      ufRemetente: sender.endereco.uf,
      cepDestinatario: recipientAddress.codigoPostal,
      modalidade
    })
    .$promise;
  }

  /**
   * solicita a lista de reversas para gerenciamento
   */
  async getReverses(params, offset, limit) {
    return this.resource.getReverses(Object.assign({
      offset,
      limit,
      situacao: params && params.situacaoEncomenda || null,
    }, params)).$promise;
  }

  /**
   * solicita a origem de uma dada reversa
   */
  async getReverseOrigin(id) {
    return this.resource.getReverseOrigin({ id }).$promise;
  }

  async deleteReverse(id) {
    return this.resource.deleteReverse({ id }).$promise;
  }

  async sendReverseAuthorization(id) {
    return this.resource.sendReverseAuthorization({ id }).$promise;
  }

  /**
   * solicita a lista de faturas
   */
  async getListaFaturas(params, offset, limit) {
    return this.resource.listaFaturas({
      offset: offset,
      limit: limit,
      numeroFatura: params && params.numeroFatura ? params.numeroFatura : null,
      valorFatura: params && angular.isDefined(params.valorFatura) ? params.valorFatura : null,
      situacaoFatura: params && params.situacaoFatura != null ? params.situacaoFatura : null,
      dataCriacaoInicial: params && params.dataCriacaoInicial ? params.dataCriacaoInicial.yyyymmdd() : null,
      dataCriacaoFinal: params && params.dataCriacaoFinal ? params.dataCriacaoFinal.yyyymmdd() : null,
      dataVencimentoInicial: params && params.dataVencimentoInicial ? params.dataVencimentoInicial.yyyymmdd() : null,
      dataVencimentoFinal: params && params.dataVencimentoFinal ? params.dataVencimentoFinal.yyyymmdd() : null,
    }).$promise;
  }

  /**
   * solicita o detalhe da fatura
   */
  async getDetalheFatura(idFatura) {
    return this.resource.detalheFatura({ idFatura }).$promise;
  }

  async getSegundaViaFatura(id) {
    return this.resource.segundaViaFatura({ id }).$promise;
  }

  /**
   * solicita a situação de uma determinada OS
   */
  async getSituacaoOs(orderId) {
    return this.resource.statusOs({ orderId }).$promise;
  }

  async getSituacaoOsV2(orderId) {
    return this.resource.statusOsV2({ orderId }).$promise;
  }

  /**
   * solicita as cordenadas de uma determinada OS
   */
  async coordinates(orderId) {
    return this.resource.coordenada({ orderId }).$promise;
  }

  /**
   * Verifica se a encomenda possui comprovante de coleta
   */
  async checkPickupReceipt(id) {
    return this.resource.checkPickupReceipt({ id }).$promise;
  }

  /**
   * Verifica se o cliente precisa de segurança na coleta
   */
  async userHasSecuriryPickUp(id) {
    return this.resource.userHasSecuriryPickUp({ id }).$promise;
  }

  /**
   * Libera a coleta
   */
  async releasePickUp(chaveAcesso) {
    return this.resource.releasePickUp({ chaveAcesso }).$promise;
  }

  /**
   * Pega os dados do motorista
   */
  async getDriverData(id) {
    return this.resource.getDriverData({ id }).$promise;
  }

  /**
   * Envia número de telefone do cliente
   */
  async pickUpWarn(phone) {
    return this.resource.pickUpWarn(phone).$promise;
  }
}
